import React from 'react';

interface ChatBubbleIconProps {
    size?: number;
    muted?: boolean;
}

const LINE_TOP_D = 'M5.45996 7.45996H14.54';
const LINE_BOTTOM_D = 'M5.45996 10.5801H11.59';
const BUBBLE_D =
    'M14.04 2.5H5.98002C3.52002 2.5 1.52002 4.5 1.52002 6.96V11C1.52002 13.46 3.52002 15.46 5.98002 15.46H11.32L15.04 19.37V15.34C17.02 14.88 18.5 13.12 18.5 11V6.96C18.5 4.5 16.5 2.5 14.04 2.5Z';

const ChatBubbleIcon: React.FC<ChatBubbleIconProps> = ({ size = 20, muted = false }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
        {[LINE_TOP_D, LINE_BOTTOM_D, BUBBLE_D].map((d) => (
            <path
                key={d}
                d={d}
                stroke={
                    muted ? 'var(--color-neutrals-textGamma)' : 'var(--color-neutrals-textAlpha)'
                }
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        ))}
    </svg>
);

export default ChatBubbleIcon;
